/**
 * Valida un IMEI: 15 dígitos numéricos y dígito verificador correcto (Luhn).
 * Se usa en la recepción por sellos para validar la serie de los Smartphone
 * (feedback inmediato en la tabla y antes de enviar el update al backend).
 */
export function isValidImei (imei: string): boolean {
  if (!imei?.trim()) {
    return false
  }

  const normalizedImei = imei.trim()
  if (normalizedImei.length !== 15 || !/^\d+$/.test(normalizedImei)) {
    return false
  }

  let sum = 0
  let shouldDouble = false
  for (let i = normalizedImei.length - 1; i >= 0; i--) {
    let digit = normalizedImei.charCodeAt(i) - 48 // '0' is 48
    if (shouldDouble) {
      digit *= 2
      if (digit > 9) {
        digit -= 9
      }
    }
    sum += digit
    shouldDouble = !shouldDouble
  }

  return sum % 10 === 0
}
